import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import TopNavigation from './TopNavigation';
import BottomNavigation from './BottomNavigation';
import './CetarusAccountPage.css';
import '../styles/buttons.css';

const CetarusAccountPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        navigate('/');
        return;
      }
      setUser(user);
      setLoading(false);
    };
    checkUser();
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (event === 'SIGNED_OUT') {
          navigate('/');
        } else if (session?.user) {
          setUser(session.user);
          setLoading(false);
        }
      }
    );
    return () => subscription.unsubscribe();
  }, [navigate]);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  // Don't show loading state - render content immediately
  // The loading state will be handled gracefully by the content

  return (
    <div className="home-container">
      <TopNavigation activePage="account" />
      <div className="home-content">
        <div className="home-header">
          <h1>Welcome to Cetarus</h1>
          <p>You've successfully signed in to your account.</p>
        </div>
        <div className="user-info">
          <h2>Account Information</h2>
          <p><strong>Email:</strong> {user?.email}</p>
          <p><strong>User ID:</strong> {user?.id}</p>
          <p><strong>Last Sign In:</strong> {user?.last_sign_in_at ? new Date(user.last_sign_in_at).toLocaleString() : 'N/A'}</p>
        </div>
        <div className="action-buttons">
          <button 
            className="btn btn--primary btn--md btn--rounded"
            onClick={() => navigate('/protocols')}
          >
            View Protocols
          </button>
          <button 
            className="btn btn--secondary btn--md btn--rounded"
            onClick={handleSignOut}
          >
            Sign Out
          </button>
        </div>
      </div>
      <BottomNavigation />
    </div>
  );
};

export default CetarusAccountPage; 

